import React from 'react';
import { FooterLink } from './FooterLink';

export const Footer: React.FC<{}> = ({}) => {
    return (
        <>
            <footer>
                <div className='footerContainer'>
                    <div className='corporateWrapper'>
                        <a
                            href='/'
                            className='logo no-print'
                        >
                            <img
                                src='/assets/img/footer-logo.png'
                                alt='Builder Finance'
                                width={'150px'}
                            />
                        </a>
                        <br />
                        <br />
                        <p className='corporateWrapper-disclaimer'>
                            Loans in the Draw section are not fully funded, but may or may not be eligible for draws
                        </p>
                        <p className='corporateWrapper-disclaimer'>© 2025 Builder Finance. All rights reserved.</p>
                    </div>
                    <div className='footerNav'>
                        <div className='footerNav-linklist'>
                            <FooterLink url='https://www.builderfinance.com/en/site-terms'>Terms of Service</FooterLink>
                        </div>
                        <div className='footerNav-linklist'>
                            <FooterLink url='https://www.builderfinance.com/en/privacy-policy'>Privacy Policy</FooterLink>
                        </div>
                        <div className='footerContact'>
                            <p>
                                <b>Phone:</b> 800-752-0401
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};
